module.exports = __webpack_public_path__ + "static/media/navbar-extra-shape-onoake.635a9942.png";